import { CONFIG } from '@/config/Config';
import axios from 'axios';
import { addSessionId } from '@/core/utils/httpHeaders';

export interface Page {
  id: string;
  username: string;
  title: string;
  instagram_id: string;
}

export async function fetchActivePages(channel: string): Promise<Page[]> {
  try {
    const accId = CONFIG.cookieOrParam('acc_id')?.split('|')[0];

    if (!accId) {
      console.warn('accId is undefined, skipping fetchActivePages');
      return [];
    }

    const headers = addSessionId({
      accept: 'application/json',
    });

    const response = await axios.get(`${CONFIG.getServiceUrl('proprietary-page')}/listing/pages/${channel}/${accId}`, {
      headers,
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching active accounts:', error);
    throw error;
  }
}
